"use client"

import { Progress as ProgressPrimitive } from "@base-ui/react/progress"

import { cn } from "@/lib/utils"

function Progress({
  className,
  trackClassName,
  indicatorClassName,
  value,
  ...props
}: ProgressPrimitive.Root.Props & {
  trackClassName?: string
  indicatorClassName?: string
}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value}
      className={cn("group/progress w-full", className)}
      {...props}
    >
      <ProgressPrimitive.Track
        data-slot="progress-track"
        className={cn(
          "relative h-2 w-full overflow-hidden rounded-full bg-primary/15",
          trackClassName
        )}
      >
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className={cn(
            "absolute top-0 h-full rounded-full bg-primary transition-[width] duration-300 ease-out",
            "group-data-[status=indeterminate]/progress:w-2/5 group-data-[status=indeterminate]/progress:animate-pulse",
            indicatorClassName
          )}
        />
      </ProgressPrimitive.Track>
    </ProgressPrimitive.Root>
  )
}

export { Progress }
